import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Typography, Flex } from 'antd';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import CustomCardContainer from 'shared/ui/CustomCardContainer/CustomCardContainer';
import { useConfirmPasswordResetMutation } from '../../reset-password/api/resetPasswordApi';
import { getResetPasswordConfirmScheme } from '../../reset-password/model/scheme';
import { ROUTES } from 'shared/const/routes';
import classes from './ResetPasswordConfirmPage.module.scss';

const ResetPasswordConfirmPage = () => {
  const { token } = useParams<{ token: string }>();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const navigate = useNavigate();
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();
  const [confirmReset, { isLoading }] = useConfirmPasswordResetMutation();

  useEffect(() => {
    if (!token) {
      navigate(ROUTES.LOGIN.path);
    }
  }, [token, navigate]);

  const onFinish = async ({ password }: { password: string }) => {
    if (!token || !email) return;
    
    try {
      await confirmReset({ token, email, password }).unwrap();
      navigate(ROUTES.LOGIN.path);
    } catch (error) {
      console.error('Password reset confirmation failed:', error);
    }
  };

  if (!token) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <Flex flex={1} justify="center" align="center">
        <CustomCardContainer className={classes.card}>
          <Typography.Text className={classes.companyName}>Weststein</Typography.Text>
          <Typography.Text className={classes.title}>
            {t({ id: 'screens.auth.password.title' })}
          </Typography.Text>
          <Typography.Paragraph className={classes.desc}>
            {t({ id: 'screens.auth.password.legend' })}
          </Typography.Paragraph>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            disabled={isLoading}
            style={{ width: '100%' }}>
            <Form.Item 
              name="password" 
              rules={getResetPasswordConfirmScheme(t).password}>
              <Input.Password
                placeholder={t({ id: 'screens.auth.signup.inputs.password' })}
              />
            </Form.Item>
            <Form.Item 
              name="repeatPassword" 
              rules={getResetPasswordConfirmScheme(t).repeatPassword}>
              <Input.Password
                placeholder={t({ id: 'screens.auth.signup.inputs.passwordConfirm' })}
              />
            </Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={isLoading} 
              block>
              {t({ id: 'screens.resetPassword.btn' })}
            </Button>
          </Form>
        </CustomCardContainer>
      </Flex>
    </div>
  );
};

export default ResetPasswordConfirmPage;
